import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCZhojia_xlDbUMSaQkvEOGh4A9ENfRroI",
  authDomain: "cadplay-techsprint.firebaseapp.com",
  projectId: "cadplay-techsprint",
  storageBucket: "cadplay-techsprint.firebasestorage.app",
  messagingSenderId: "987606694792",
  appId: "1:987606694792:web:96e170b88e17ad8665583d"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Debug: Check if Firebase is properly initialized
console.log('Firebase initialized:', app.name);
console.log('Auth initialized:', auth.app.name);
